import React from "react";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import UploadSpeedTestContainer from "./UploadSpeedTestContainer.js";
import parse from "html-react-parser";
import "./SpeedTest.scss";

const SpeedTest = () => {
  const { getPageText } = useContent();
  return (
    <div className="speed-test-warpper">
      <div className="container-speed-test">
        <div className="all-speed-section">
          <h1>
            {getPageText().Display_title
              ? parse(getPageText().Display_title)
              : null}
          </h1>
          <UploadSpeedTestContainer />
        </div>
      </div>
    </div>
  );
};

export default SpeedTest;
